import NoticebarModule from './noticebar.module'

export default NoticebarModule
